<template>
  <aicc-page :pageId="contextPageId">
    <ur-area>
      <!-- 조회 조건 -->
      <ur-form-box toggleable column="5">
        <ur-form-row>
          <ur-form-item label="요청일자" :vertical="false" labelAlign="right" colSpan="2">
            <aicc-range-picker v-model="rangePickerValue" inputType="YYYY-MM-DD" modelType="YYYY-MM-DD" Name init="none" autoConfirm />
          </ur-form-item>
          <ur-form-item label="시나리오"  :vertical="false" labelAlign="right" colSpan="2">
            <autoMultiDropdown :items="scenarioNameItems" v-model="scenarioName" applyBtn selectAll :itemsSize="300" placeholder="전체" />
          </ur-form-item>
        </ur-form-row>
        <ur-form-row>
          <ur-form-item label="요청자" :vertical="false" labelAlign="right" colSpan="2">
            <ur-text-field v-model="scenarioListAsk.fstRgstUsrNm" placeholder="이름 입력" :disabled="false" :clearable="true" :readonly="false" :width="300" @blur="onBlurTrim"/>
          </ur-form-item>
          <ur-form-item label="상태" :vertical="false" labelAlign="right" colSpan="2">
            <autoMultiDropdown :items="statusItems" v-model="status"  applyBtn selectAll :itemsSize="300" placeholder="전체" />
          </ur-form-item>
          <ur-form-item no-label noFlex>
            <ur-button shape="solid" primary @click="onClickSearch()">조회</ur-button>
          </ur-form-item>
        </ur-form-row>
      </ur-form-box>
      <!-- 시나리오 생성 프로세스 -->
      <div class="manage_scenario">
        <div class="box_gray">
          <dl>
            <dt>시나리오 생성 프로세스</dt>
            <dd><strong>step 1. 시나리오 접수중</strong>시나리오 접수 후 큐레이터 배정중 </dd>
            <dd><strong>step 2. 큐레이터 작업중</strong>큐레이터 배정 후 작업 진행중</dd>
            <dd><strong>step 3. 테스트 가능</strong>테스트 챗봇 활성화</dd>
            <dd><strong>step 4. 서비스 운영중</strong>콜 테스트 및 캠페인 적용 가능</dd>
            <dd>
              * 콜 테스트는 담당 큐레이터가 운영모드로 전환한 이후부터 사용 가능합니다.<br>단계별 상세 일정은 담당 큐레이터를 통해 별도 문의 부탁드립니다.
            </dd>
          </dl>
        </div>
      </div>
      <!-- 시나리오 리스트 -->
      <div class="data_tbl_list">
        <ur-data-grid :headers="headers" :options="options" :data-source="dataList" ref="grid" @grid:click="clickEvent" >
          <template #right-info>
            <!-- <ur-button primary icon="new_file" large @click="onClickConfirmModal()">시나리오 만들기</ur-button> -->
            <ur-button primary icon="new_file" large @click="onClickAddScenario()">시나리오 만들기</ur-button>
          </template>
        </ur-data-grid>
      </div>
      <!-- 시나리오 만들기 확인 모달 -->
      <ur-modal ref="confirmModal" :title="'안내'" small>
        <template>
          현재 사용중인 시나리오는 총 {{scenarioCount}} 개입니다.({{scenarioCount}}/{{scenarioLimit}})
        </template>
        <template slot="action">
          <ur-button shape="solid" color="primary" @click="onClickAddScenario()" >확인</ur-button>
        </template>
      </ur-modal>
    </ur-area>
  </aicc-page>
</template>

<script>
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';
import BasePage from '~cm/components/BasePage';
import CMP_AIC_00001 from '../../components/CMP_AIC_00001.vue';

// 윈도우 팝업 중복 방지
if (!window.PGE_AID_00001_popupWindowMap) {
  window.PGE_AID_00001_popupWindowMap = new Map();
}

// 시나리오 만들기 완료시 시나리오 리스트 갱신하도록 flag 변경
let refreshEnabled = false;
window.setRefreshEnabled = function setRefreshEnabled() {
  refreshEnabled = true;
};

export default {
  name: 'PGE_AID_00001', // eslint-disable-line vue/name-property-casing
  components: {
    autoMultiDropdown: CMP_AIC_00001,
    urDataGrid,
  },
  extends: BasePage,
  data() {
    return {
      // 데이터 그리드
      dataList: [],
      items: [],
      headers: [
        { text: '상태', value: 'status', width: '112px', sort: false, type: 'code',
          domain: aiccCode.scenarioServiceRequestStatus.valueTextArray,
          component: {
            props: ['row', 'value', 'text'],
            template: '<span><strong :class="statusClass">{{text}}</strong></span>',
            computed: {
              statusClass() {
                return {
                  A: 'status lg ing', // green
                  B: 'status lg waiting', // orange
                  C: 'status lg waiting', // orange
                  D: 'status lg done', // blue
                  E: 'status lg cancel', // grey
                  F: 'status lg cancel', // grey
                }[this.value] || 'status lg cancel'; // default
              },
            },
          },
        },
        { text: '구분', value: 'scenarioType', width: '60px', sort: true },
        { text: '시나리오', value: 'scenarioName', sort: true,
          customClass : function(v, r) {
            if (r.readable === true) return 'data-grid-cursor';
          },
        },
        { text: '요청자', value: 'fstRgstUsrNm', width: '176px', sort: aiccUtils.sortNull,
          customClass : function(v, r) {
            if (r.readable === true) return 'data-grid-cursor';
          },
        },
        { text: '담당 큐레이터', value: 'curatorUsrNm', width: '316px', sort: aiccUtils.sortNull,
          customValue: (value, row) => {
            if (value == null || value === '') {
              return '배정중';
            }

            if (row.email == null || row.email === '') {
              return value;
            }

            return `${value}(${row.email})`;
          },
          customClass : function(v, r) {
            if (r.readable === true) return 'data-grid-cursor';
          },
        },
        { text: '요청일자', value: 'fstRgstDtm', width: '116px', sort: true,
          customClass : function(v, r) {
            if (r.readable === true) return 'data-grid-cursor';
          },
        },
        { text: '완료일자', value: 'completionDate', width: '116px', sort: aiccUtils.sortNull,
          customClass : function(v, r) {
            if (r.readable === true) return 'data-grid-cursor';
          },
        },
        { text: '테스트 실행', value: 'test', width: '180px', sort: false, align : 'center',
          component: {
            props: ['row', 'value', 'text'],
            template: '<span v-if="row.testable"><button type="button" class="btn btn_test_chat">테스트</button></span>',
          },
        },
      ],
      options: {
        infinityScroll: true,
        msgTotal: '총 #',
        msgAscending: '오름차순 정렬',
        msgDescending: '내림차순 정렬',
        msgEmptyData: '', // 조회 완료 후에 문구 출력
      },

      // 조회조건
      scenarioListAsk: {
        startFstRgstDtm: '',
        endFstRgstDtm: '',
        scenarioIdList: [],
        fstRgstUsrNm: '',
        statusCodeList: [],
      },
      rangePickerValue: ['', ''],

      // 시나리오명
      scenarioName: [], // 선택
      scenarioNameItems: [], // 전체

      // 상태
      status: [], // 선택
      statusItems: [], // 전체

      // 발화조건
      // speechConditionItems: [],

      // 테스트 실행
      testAsk: {
        scenarioId: '',
        // speechCondition: '',
      },

      // 윈도우 팝업
      popupWindowMap: null,
      detailWindowOptions: 'width=1330,height=1080,location=no,menubar=no,status=no,toolbar=no,resizable=yes',
      addWindowOptions: 'width=1280,height=890,location=no,menubar=no,status=no,toolbar=no,resizable=yes',
      testWindowOptions: 'width=386,height=853,location=no,menubar=no,status=no,toolbar=no,resizable=yes',

      // 시나리오 갯수
      scenarioCount: '',
      scenarioLimit: '',
    };
  },
  computed: {
  },
  watch: {
    rangePickerValue() { // 요청일자 선택시 나머지 조회조건 초기화. 단, 동일한 요청일자 선택시 초기화하지 않음
      this.getScenarioNameItems();
      this.getStatusItems();
      this.scenarioListAsk.fstRgstUsrNm = '';
    },
  },
  created() {
    this.popupWindowMap = window.PGE_AID_00001_popupWindowMap;
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      this.addWindowEventListener();
      this.getScenarioNameItems();
      this.getStatusItems();
      this.onClickSearch();
    },

    // 시나리오명 리스트 조회
    getScenarioNameItems() {
      // 요청일자
      const dataParams = { // 시나리오명 리스트에는 요청일자에 해당하는 데이터만 표시
        startFstRgstDtm: utils.toStringByFormat(utils.toDate(this.rangePickerValue[0]), 'YYYYMMDD'),
        endFstRgstDtm: utils.toStringByFormat(utils.toDate(this.rangePickerValue[1]), 'YYYYMMDD'),
      };

      http.request(this.contextPageId, 'DTS_AID_00001', {
        data: dataParams,
      }).then(res => {
        this.scenarioNameItems = [];

        for (var item in res.data.scenarioList) {
          this.scenarioNameItems.push(
            {
              text: res.data.scenarioList[item].scenarioName,
              value: res.data.scenarioList[item].scenarioId,
            }
          );
          this.scenarioName = this.scenarioNameItems; // 전체 선택이 default
        }
      });
    },

    // 상태 리스트 조회
    getStatusItems() {
      this.statusItems = [];
      this.$nextTick(() => {
        this.statusItems = aiccCode.scenarioServiceRequestStatus.valueTextArray;
        this.status = this.statusItems; // 전체 선택이 default
      });
    },

    // 발화조건 리스트 조회
    // getSpeechConditionItems(value) {
    //   this.testAsk.speechCondition = '';
    //   this.speechConditionItems = [
    //     {
    //       text: '전체',
    //       value: '',
    //     },
    //   ];

    //   const codeAsk = {
    //     scenarioId: value,
    //     codeType: 'AA',
    //   };
    //   http.requestTest('post', '/api/v1/scenario/code', {
    //   // http.request(this.contextPageId, 'DTS_AID_00002', {
    //     data: codeAsk,
    //   }).then(res => {
    //     for (var item in res.data.codeList) {
    //       this.speechConditionItems.push(
    //         {
    //           text: res.data.codeList[item].codeName,
    //           value: res.data.codeList[item].codeValue,
    //         }
    //       );
    //     }
    //   });
    // },

    // 시나리오 조회
    onBlurTrim() {
      this.scenarioListAsk.fstRgstUsrNm = this.scenarioListAsk.fstRgstUsrNm.trim();
    },
    onClickSearch() {
      // 요청일자
      this.scenarioListAsk.startFstRgstDtm = utils.toStringByFormat(utils.toDate(this.rangePickerValue[0]), 'YYYYMMDD');
      this.scenarioListAsk.endFstRgstDtm = utils.toStringByFormat(utils.toDate(this.rangePickerValue[1]), 'YYYYMMDD');

      // 시나리오
      this.scenarioListAsk.scenarioIdList = [];
      for (var item in this.scenarioName) {
        this.scenarioListAsk.scenarioIdList.push(this.scenarioName[item].value);
      }

      // 상태
      this.scenarioListAsk.statusCodeList = [];
      for (var item in this.status) {
        this.scenarioListAsk.statusCodeList.push(this.status[item].value);
      }

      http.request(this.contextPageId, 'DTS_AID_00001', {
        data: this.scenarioListAsk,
      }).then(res => {
        let rowList = []; // 화면용 list
        for (var scenario of res.data.scenarioList) {
          // row list 채움
          let row = {};
          row.scenarioId = scenario.scenarioId;
          row.status = scenario.statusCode;
          row.scenarioType = aiccCode.scenarioRequestType.codeText(scenario.scenarioType);
          row.scenarioName = scenario.scenarioName;
          row.fstRgstUsrNm = scenario.fstRgstUsrNm;
          row.curatorUsrNm = scenario.curatorUsrNm;
          row.email = scenario.email;
          row.fstRgstDtm = this.changeDateformat(scenario.fstRgstDtm);
          row.completionDate = this.changeDateformat(scenario.completionDate);
          row.readable = scenario.readable;
          row.testable = scenario.testable;

          rowList.push(row);
        }

        this.dataList = rowList; // row list를 화면용 list에 넘김
        this.options.msgEmptyData = '선택하신 조건의 조회결과가 없습니다.';
      });
    },

    // 메인화면을 종료할 때, 윈도우 팝업을 모두 종료
    addWindowEventListener() {
      window.addEventListener('beforeunload', this.closeWindowPopup);
    },
    closeWindowPopup() {
      for (var item of this.popupWindowMap) {
        item[1].close();
      }
    },

    // 시나리오 상세 조회
    onClickDetailScenario(item) {
      const queryString = `scenarioId=${item.scenarioId}`;
      const url = `/popup.html#/PGE_AID_00002?${queryString}`;
      const centerPopupOption = aiccUtils.popupUtil.getCenterPopupOption(this.detailWindowOptions);

      if (!this.popupWindowMap.has(item.scenarioId) || this.popupWindowMap.get(item.scenarioId).closed === true) { // 최초 팝업
        this.popupWindowMap.set(item.scenarioId, window.open(window.location.pathname + url, '', centerPopupOption));
      } else { // 중복 팝업
        this.popupWindowMap.get(item.scenarioId).focus();
      }
    },

    // 시나리오 만들기
    onClickConfirmModal() {
      this.getScenarioCount();
      this.$refs.confirmModal.open();
    },
    getScenarioCount() {
      http.request(this.contextPageId, 'DTS_AID_00006', {
      }).then(res => {
        this.scenarioCount = res.data.scenarioCount;
        this.scenarioLimit = res.data.scenarioLimit;
      });
    },
    onClickAddScenario() {
      this.$refs.confirmModal.close();
      const url = '/popup.html#/PGE_AID_00003';
      const key = 'addWindowKey';
      const centerPopupOption = aiccUtils.popupUtil.getCenterPopupOption(this.addWindowOptions);

      if (!this.popupWindowMap.has(key) || this.popupWindowMap.get(key).closed === true) { // 최초 팝업
        this.popupWindowMap.set(key, window.open(window.location.pathname + url, '', centerPopupOption));
        this.popupWindowMap.get(key).addEventListener('beforeunload', this.refreshScenarioList); // 시나리오 만들기 화면 종료시 시나리오 리스트 갱신을 위한 이벤트 리스너
      } else { // 중복 팝업
        this.popupWindowMap.get(key).focus();
      }
    },
    refreshScenarioList() {
      if (refreshEnabled) { // 시나리오 만들기 화면 종료시 flag에 따라 시나리오 리스트 갱신 및 조회조건 초기화(요청일자 제외)
        refreshEnabled = false;
        this.scenarioListAsk.fstRgstUsrNm = '';
        this.scenarioName = [];
        this.status = [];

        this.onClickSearch();
        this.getScenarioNameItems();
        this.getStatusItems();
      }
    },

    // 테스트 실행
    // onClickTestModal(item) {
    //   this.testAsk.scenarioId = item.scenarioId;
    //   this.getSpeechConditionItems(item.scenarioId);
    //   this.$refs.testModal.open();
    // },
    onClickTest(item) {
      this.testAsk.scenarioId = item.scenarioId;
      // this.$refs.testModal.close();      
      http.request(this.contextPageId, 'DTS_AID_00003', {
        data: this.testAsk,
      }).then(res => {
        if (res.data.reply.code === '0000') {
          const key = 'testWindowKey';
          const centerPopupOption = aiccUtils.popupUtil.getCenterPopupOption(this.testWindowOptions);
          if (this.popupWindowMap.has(key) && this.popupWindowMap.get(key).closed === false) { // 중복 팝업
            this.popupWindowMap.get(key).close(); // 시나리오 관리 화면에서 웹챗 테스트는 동시에 하나의 시나리오만 허용 --> 중복 팝업시 종료 후 재실행
          }
          this.popupWindowMap.set(key, window.open(res.data.webchatUrl, '', centerPopupOption));
        } else {
          utils.aiccMessageBox('확인', res.data.reply.korMsg, '확인', null);
        }
      });
    },

    // 일자 형식 YYYYMMDD -> YYYY-MM-DD
    changeDateformat(date) {
      return utils.dateformatToClient(date, 'S');
    },

    // 데이터 그리드
    clickEvent(cell, row, field, e) {
      if (typeof e === 'object') {
        if (e.button === 0) { // 마우스 메인 버튼만 유효
          if (field.value === 'test') { // 테스트 실행 컬럼
            if (row.testable) {
              // this.onClickTestModal(row);
              this.onClickTest(row);
            }
          } else {
            if (row.readable) {
              this.onClickDetailScenario(row);
            }
          }
        }
      }
    },
  },
};
</script>

<style scoped>
</style>
